export default __webpack_public_path__ + "static/media/7.02038687.svg";